import * as React from 'react';

interface IProps {
  isDetail: boolean;
}

export default function LeftAxis(props: IProps) {
  return (
    <div>
      <div
        style={{
          position: 'absolute',
          top: props.isDetail ? '18px' : '9px',
          // left: '-17px',
          width: '1px',
          height: props.isDetail ? '79px' : '50px',
          background: '#1C957A',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '-7px',
            left: '-18px',
            color: '#1C957A',
          }}
        >
          10
          <div
            style={{
              position: 'absolute',
              top: '6px',
              left: '18px',
              borderTop: '1px solid #1C957A',
              width: '12px',
            }}
          />
        </div>
        <div
          style={{
            position: 'absolute',
            top: props.isDetail ? '62px' : '22px',
            left: '-14px',
            color: '#1C957A',
          }}
        >
          8
          <div
            style={{
              position: 'absolute',
              top: '9px',
              left: '14px',
              borderBottom: '1px solid #1C957A',
              width: '12px',
            }}
          />
        </div>
      </div>
      <div
        style={{
          position: 'absolute',
          top: props.isDetail ? '90px' : '39px',
          // left: '-17px',
          width: '1px',
          height: props.isDetail ? '112px' : '60px',
          background: '#df731d',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: props.isDetail ? '62px' : '24px',
            left: '-13px',
            color: '#df731d',
          }}
        >
          6
          <div
            style={{
              position: 'absolute',
              top: '9px',
              left: '14px',
              borderBottom: '1px solid #df731d',
              width: '12px',
            }}
          />
        </div>
      </div>
      <div
        style={{
          position: 'absolute',
          top: props.isDetail ? '200px' : '88px',
          // left: '-17px',
          width: '1px',
          height: props.isDetail ? '178px' : '82px',
          background: '#b50536',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: props.isDetail ? '24px' : '7px',
            left: '-13px',
            color: '#b50536',
          }}
        >
          4
          <div
            style={{
              position: 'absolute',
              top: '9px',
              left: '14px',
              borderBottom: '1px solid #b50536',
              width: '12px',
            }}
          />
        </div>
        <div
          style={{
            position: 'absolute',
            top: props.isDetail ? '96px' : '40px',
            left: '-13px',
            color: '#b50536',
          }}
        >
          2
          <div
            style={{
              position: 'absolute',
              top: '9px',
              left: '14px',
              borderBottom: '1px solid #b50536',
              width: '12px',
            }}
          />
        </div>
        <div
          style={{
            position: 'absolute',
            top: props.isDetail ? '168px' : '72px',
            left: '-13px',
            color: '#b50536',
          }}
        >
          0
          <div
            style={{
              position: 'absolute',
              top: '9px',
              left: '14px',
              borderBottom: '1px solid #b50536',
              width: '12px',
            }}
          />
        </div>
      </div>
    </div>
  );
}
